import { ID_NUMBERS_COMPARENTI } from 'civil-status/components/step/form/last-step/accordions/section/list/list-number';
import { CodeSection, CodeSubject } from 'civil-status/constants/code-subject-section';
import {
  DataWizardAct,
  ParentVM,
  QuestionarioEvento,
  StatoCivile,
  Evento,
  RecapVM,
  SoggettoList,
  DatiNascita,
  DatiDichiarante,
  EnteDichiaranteList,
  DatiMorte,
  SectionVM,
  DatiEventoMorte,
  DatiEventoCittadinanza,
  CertificatoSanitario,
  DatiEventoRiconoscimento,
  TrascrizioneNascita,
  TrascrizioneMorte,
  Ascendente,
  TextActVM,
  AttoCollegato,
  TrascrizioneCittadinanza,
  Consenso,
  DatiAssenso,
  Luogo,
  DatiAnnotazioneList,
  UnioneCivileAtti,
  CertificatoUnioneCivileList,
  RegimePatrimoniale,
  Impedimento,
  MatrimonioAtti,
  ScioglimentoUnioneCivileAtti,
  Pubblicazione,
  TrascrizioneUnioneCivile,
  Separazione,
  TrascrizioneMatrimonioAtti,
  NegoziazioneAssistita,
  DatiIntegrativiTrascrizione,
  TrascrizioneSeparazioneAtti,
  Riconciliazione,
  RiconoscimentoList,
  Richiedente,
  FiglioList,
  AnnotazioneModificativa,
} from 'civil-status/view-models/step-form';
import { transformerQuestionario } from './transformer-questionario';
import { transformerStatoCivile } from './transformer-stato-civile';
import { transformerEvento } from './transformer-evento';
import { transformerSoggettoList } from './transformer-soggetto-list';
import { transformerDatiNascita } from './transformer-dati-nascita';
import { transformerDatiDichiarante } from './transformer-dati-dichiarante';
import { transformerEnteDichiarante } from './transformer-ente-dichiarante';
import { transformerDatiMorte } from './transformer-dati-morte';
import { transformerDatiEventoMorte } from './transformer-dati-evento-morte';
import { transformerDatiEventoCittadinanza } from './transformer-dati-evento-cittadinanza';
import { transformerCertificatoSanitario } from './transformer-certificato-sanitario';
import { transformerDatiEventoRiconoscimento } from './transformer-dati-evento-riconoscimento';
import { transformerTrascrizioneNascita } from './transformer-trascrizione-nascita';
import { transformerTrascrizioneMorte } from './transformer-trascrizione-morte';
import { transformerAscendente } from './transformer-ascendente';
import { transformerAttoCollegatoList } from './transformer-atto-collegato-list';
import { subjectIsVisibility } from '../subject-is-visibility';
import { transformerTrascrizioneCittadinanza } from './transformer-trascrizione-cittadinanza';
import { transformerConsenso } from './transformer-consenso';
import { sectionIsVisibility } from '../section-is-visibility';
import { typePresence } from 'civil-status/constants/type-presence';
import { isObjectEmpty } from 'shell/utils/is-object-empty';
import { clearSectionMomentary } from '../clear-section';
import { transformerDatiAssenso } from './transformer-dati-assenso';
import { clearSubjectMomentary } from '../clear-subject';
import { transformerLuogo } from './transformer-luogo';
import { ConfigurationType } from 'civil-status/constants/configuration-type';
import { transformerDatiAnnotazioneList } from './transformer-dati-annotazione-list';
import { transformerUnioneCivileAtti } from './transformer-unione-civile-atti';
import { transformerCertificatoUnioneCivileList } from './transformer-certificato-unione-civile-list';
import { transformerRegimePatrimoniale } from './transformer-regime-patrimoniale';
import { transformerImpedimento } from './transformer-impedimento';
import { transformerMatrimonioAtti } from './transformer-matrimonio-atti';
import { transformerScioglimentoUnioneCivileAtti } from './transformer-scioglimento-unione-civile-atti';
import { withInterprete } from '../with-interprete';
import { transformerPubblicazioneList } from './transformer-pubblicazione-list';
import { transformerTrascrizioneUnioneCivile } from './transformer-trascrizione-unione-civile';
import { transformerSeparazione } from './transformer-separazione';
import { transformerTrascrizioneMatrimonioAtti } from './transformer-trascrizione-matrimonio-atti';
import { transformerNegoziazioneAssistita } from './transformer-negoziazione-assistita';
import { transformerDatiIntegrativiTrascrizione } from './transformer-dati-integrativi-trascrizione';
import { transformerTrascrizioneSeparazioneAtti } from './transformer-trascrizione-separazione-atti';
import { transformerRiconciliazione } from './transformer-riconciliazione';
import { CodeSectionAttoCollegatoList } from 'civil-status/constants/code-section-atto-collegato-list';
import { CodeSectionEventoRiconoscimento } from 'civil-status/constants/code-section-evento-riconoscimento';
import { CodeSectionEnteDichiarante } from 'civil-status/constants/code-section-ente-dichiarante';
import { CodeSectionRiconsocimentoList } from 'civil-status/constants/code-section-riconsocimento-list';
import { withInterpreteCheck } from '../with-interprete-check';
import { transformerRichiedente } from './transformer-richiedente';
import { keyAllChildren } from 'civil-status/constants/key-all-children';
import { transformerFiglioList } from './transformer-figlio-list';
import { transformerAnnotazioneModificativa } from './transformer-annotazione-modificativa';

export const transformerActWizardToSave = (
  isSaveSingle: boolean, // true => se salvataggio è del singolo soggetto o singola sezione
  data: Array<RecapVM>,
  idEvento?: number,
  dateFormationAct?: string,
  subjects?: Array<ParentVM>,
  sections?: Array<SectionVM>,
  valuesText?: TextActVM,
  idValore?: string,
  descrizioneValore?: string,
  isLastStepEmergency?: boolean
): DataWizardAct => {
  // dati soggetti per salvataggio
  const dichiaranti = subjects?.filter((item) => item?.flagDichiarante === '1');
  const subjectUniciv = subjects?.filter(
    (item) => item?.codeSubject === CodeSubject.UNICIV1 || item?.codeSubject === CodeSubject.UNICIV2
  );
  const nascituro = subjects?.find(
    (item) =>
      item?.codeSubject === CodeSubject.INT_NAS ||
      item?.codeSubject === CodeSubject.INT_NAS2 ||
      item?.codeSubject === CodeSubject.INT_NAS2_C1
  );
  const subjectCittadinanza = subjects?.find((item) => item?.codeSubject === CodeSubject.INTEST);
  const valuesDeceduto: ParentVM | undefined = subjects?.find(
    (item) => item?.codeSubject === CodeSubject.DECEDUTO
  );
  const dataAscendente: ParentVM | undefined = subjects?.find(
    (item) => item?.codeSubject === CodeSubject.ASCEN
  );
  const subjectIntest1 = subjects?.find((item) => item?.codeSubject === CodeSubject.INTEST1);

  const subjectOfficianteCitt = subjects?.find(
    (item) => item?.codeSubject === CodeSubject.OFFICIANTE_CITT
  );

  const subjectOfficianteTras = subjects?.find(
    (item) => item?.codeSubject === CodeSubject.OFFICIANTE_TRAS
  );

  // dati sezioni per salvataggio
  const dataEventoRiconoscimento = sections?.find((item) =>
    CodeSectionEventoRiconoscimento.includes(item.codeSection as CodeSection)
  );
  const valuesDatiSpecificiCittadinanza: SectionVM | undefined = sections?.find(
    (item) => item?.codeSection === CodeSection.DATI_SPECIFICI_CITTADINANZA
  );
  const dataDatiGeneraliRiconoscimento = sections?.find(
    (item) => item?.codeSection === CodeSection.DATI_GENERALI_RICONOSCIMENTO
  );
  const dataTranscriptionBorn = sections?.find(
    (item) =>
      item?.codeSection === CodeSection.DATI_TRASCRIZIONE ||
      item?.codeSection === CodeSection.DATI_TRASCRIZIONE_TP_RICHIEDENTE_FG
  );

  const dataTranscriptionBornTP = sections?.find(
    (item) => item?.codeSection === CodeSection.DATI_TRASCRIZIONE_TP_RICHIEDENTE
  );

  const dataAnnModificativa = sections?.find(
    (item) => item?.codeSection === CodeSection.DG_ANNOTAZIONE_MODIFICATIVA
  );

  const dataTranscriptionBirth = sections?.find(
    (item) => item?.codeSection === CodeSection.TRASCRIZIONE_NASCITA
  );
  const dataSpecificCivilUnion = sections?.find(
    (item) => item?.codeSection === CodeSection.DATI_SPECIFICI_UNICIV
  );
  const dataRegimePatrimoniale = sections?.find(
    (item) => item?.codeSection === CodeSection.REGIME_PATRIMONIALE
  );
  const dataMatrimonioAtti = sections?.find(
    (item) => item?.codeSection === CodeSection.DATI_SPECIFICI_MATR
  );
  const dataSepar = sections?.find((item) => item?.codeSection === CodeSection.DATI_SEPAR);
  const dataTranscriptionSeparation = sections?.find(
    (item) => item?.codeSection === CodeSection.DATI_TRASCRIZIONE_SEPARAZIONE
  );
  const dataDatiRiconcilianzione = sections?.find(
    (item) => item?.codeSection === CodeSection.DATI_RICONCILIAZIONE
  );
  const dataDatiSeparazioniUC = sections?.find(
    (item) => item?.codeSection === CodeSection.DATI_SEPARUC
  );
  const transcriptionCitizenship = sections?.find(
    (item) => item?.codeSection === CodeSection.TRASCRIZIONE_CITTADINANZA
  );

  const sectionsFiltred = sections?.filter((itemSection) => {
    if (isSaveSingle) {
      return true;
    }

    const valuesMomentary = { ...(itemSection || {}), ...clearSectionMomentary() };

    if (
      (itemSection.typePresence === typePresence.Facoltativo ||
        itemSection.typePresence === typePresence.FacoltativoObbligatorio) &&
      isObjectEmpty((valuesMomentary || {}) as Record<string, unknown>)
    ) {
      // se falcolatativo e l'oggetto è vuoto non salvare
      return false;
    }

    return sectionIsVisibility(
      itemSection,
      dataEventoRiconoscimento || dataDatiGeneraliRiconoscimento,
      valuesDatiSpecificiCittadinanza,
      nascituro,
      dataTranscriptionBorn || dataTranscriptionBornTP,
      dataSpecificCivilUnion || dataMatrimonioAtti,
      dataRegimePatrimoniale,
      dataSepar || dataTranscriptionSeparation,
      dataDatiRiconcilianzione,
      transcriptionCitizenship,
      valuesDeceduto,
      isLastStepEmergency
    );
  });

  const dataDead = sectionsFiltred?.find((item) => item?.codeSection === CodeSection.DATI_DECESSO);
  const dataAgreeSon = sectionsFiltred?.find(
    (item) =>
      item?.codeSection === CodeSection.ASSENSO_FIGLIO ||
      item?.codeSection === CodeSection.ATTO_ASSENSO_FIGLIO ||
      item?.codeSection === CodeSection.ATTO_ASSENSO_FIGLIO_RESO
  );
  const dataCittadinanza = sectionsFiltred?.find(
    (item) =>
      item?.codeSection === CodeSection.DATI_SPECIFICI_CITTADINANZA ||
      item?.codeSection === CodeSection.DATI_EVENTO_CITTADINANZA
  );
  const dataDatiRegistroEmergenza = sectionsFiltred?.find(
    (item) => item?.codeSection === CodeSection.DATI_REGISTRO_EMERGENZA
  );
  const dataDatiGenerali = sectionsFiltred?.find(
    (item) => item?.codeSection === CodeSection.DATI_GENERALI
  );
  const dataDatiGen = sectionsFiltred?.find((item) => item?.codeSection === CodeSection.DATI_GEN);
  const dataDatiGeneraliNegoz = sectionsFiltred?.find(
    (item) => item?.codeSection === CodeSection.DATI_GENERALI_NEGOZ
  );
  const dataDatiGeneraliMancatoConsenso = sectionsFiltred?.find(
    (item) => item?.codeSection === CodeSection.TIPO_MANCATO_CONS_MADRE
  );
  const dataAutorizzazioneRiconoscimento =
    isSaveSingle || dataDatiGeneraliRiconoscimento?.isIncestuousSonSentence
      ? sectionsFiltred?.find(
          (item) => item?.codeSection === CodeSection.AUTORIZZAZIONE_RICONOSCIMENTO_PADRE
        )
      : undefined;
  const dataTranscriptionDead = sectionsFiltred?.find(
    (item) => item?.codeSection === CodeSection.DATI_TRASCRIZIONE_MORTE
  );
  const dataTranscriptionCivilUnion = sectionsFiltred?.find(
    (item) => item?.codeSection === CodeSection.DATI_TRASCRIZIONE_UNIONE_CIVILE
  );
  const dataTranscriptionMarriage = sectionsFiltred?.find(
    (item) => item?.codeSection === CodeSection.DATI_TRASCRIZIONE_MATRIMONIO
  );
  const dataMarriage = sectionsFiltred?.find(
    (item) => item?.codeSection === CodeSection.DATI_MATRIMONIO
  );
  const dataTranscriptionCitizenship = sectionsFiltred?.find(
    (item) =>
      item?.codeSection === CodeSection.DATI_TRASCRIZIONE_CITTADINANZA ||
      item?.codeSection === CodeSection.GENIT_CHE_TRASMETTE_CIT // TODO verificare se esiste ancora questo codice sezione: DATI_TRASCRIZIONE_CITTADINANZA
  );
  const dataTranscriptionNegoz = sectionsFiltred?.find(
    (item) => item?.codeSection === CodeSection.DATI_TRASCRIZIONE_NEGOZ
  );
  const dataDatiProvvedimento = sectionsFiltred?.find(
    (item) => item?.codeSection === CodeSection.DATI_PROVVEDIMENTO
  );
  const dataCivilUnion = sectionsFiltred?.find(
    (item) => item?.codeSection === CodeSection.DATI_UNIONE_CIVILE
  );
  const dataGenitoreTrasmetteCittadinanza = sectionsFiltred?.find(
    (item) => item?.codeSection === CodeSection.GENIT_CHE_TRASMETTE_CIT
  );
  const dataRicGenitoreItaliano = sectionsFiltred?.find(
    (item) => item?.codeSection === CodeSection.RIC_GENITORE_ITALIANO
  );
  const dataEsiAccProvvSindaco = sectionsFiltred?.find(
    (item) =>
      item?.codeSection === CodeSection.ESI_ACC_PROVV_SIND ||
      item?.codeSection === CodeSection.ESI_ACC_PROVV_SIND2
  );
  const dataPubblicoImpiego = sectionsFiltred?.find(
    (item) => item?.codeSection === CodeSection.PUBBLICO_IMPIEGO
  );
  const dataSupplementary = sectionsFiltred?.find(
    (item) =>
      item?.codeSection === CodeSection.DATI_INTEGRAZIONE ||
      item.codeSection === CodeSection.DATI_SPECIFICI_MATR ||
      item.codeSection === CodeSection.DATI_SPECIFICI_UNICIV
  );
  const dataAttoConsensoAcoP = sectionsFiltred?.find(
    (item) => item?.codeSection === CodeSection.ATTO_DI_CONSENSO_ATCOP
  );
  const dataAttoCollegatoList = sectionsFiltred?.filter((item) =>
    CodeSectionAttoCollegatoList.includes(item.codeSection as CodeSection)
  );
  const dataComposizioneAtto = sectionsFiltred?.find(
    (item) => item?.codeSection === CodeSection.COMPOSIZIONE_LIBERA_ATTO
  );
  const dataComposizioneAttoDue = sectionsFiltred?.find(
    (item) =>
      item?.codeSection === CodeSection.COMPOSIZIONE_LIBERA_ATTO_DUE ||
      item?.codeSection === CodeSection.ANNOTAZIONE_RETTIFICATIVA ||
      item?.codeSection === CodeSection.ANNOTAZIONE_MODIFICATIVA
  );
  const testoDelegaUnioneCivile = sectionsFiltred?.find(
    (item) => item?.codeSection === CodeSection.TESTO_DELEGA_UNIONE_CIVILE
  );
  const testoDelegaMatrimonio = sectionsFiltred?.find(
    (item) => item?.codeSection === CodeSection.TESTO_DELEGA_MATRIMONIO
  );
  const dataUltimoLuogo = sectionsFiltred?.find(
    (item) => item?.codeSection === CodeSection.ULTIMO_LUOGO
  );
  const dataAnnotations = sectionsFiltred?.find(
    (item) => item?.codeSection === CodeSection.ANNOTAZIONE_CONTESTUALE
  );
  const dataCertCivilUnionList = sectionsFiltred?.filter(
    (item) =>
      item?.codeSection === CodeSection.CERT_RIC_UNICIV_1 ||
      item?.codeSection === CodeSection.CERT_RIC_UNICIV_2
  );
  const dataImpedimento = sectionsFiltred?.filter(
    (item) =>
      item?.codeSection === CodeSection.CERT_IMPEDIMENTO_GENERICO ||
      item?.codeSection === CodeSection.CERT_IMPEDIMENTO_SPOSO ||
      item?.codeSection === CodeSection.CERT_IMPEDIMENTO_SPOSA
  );
  const dataScioglimentoUnioneCivileAtti = sectionsFiltred?.find(
    (item) => item?.codeSection === CodeSection.SCIOGLIMENTO_UNIONE_CIVILE_COMUNICAZIONE
  );
  const dataPubblicazioneList = sectionsFiltred?.filter(
    (item) =>
      item?.codeSection === CodeSection.PUBBLICAZIONE_1 ||
      item?.codeSection === CodeSection.PUBBLICAZIONE_2
  );
  const dataLawCitizenship = sectionsFiltred?.find(
    (item) => item?.codeSection === CodeSection.LEGGE_CITTADINANZA
  );

  // campi da salvare

  const questionarioEvento: Array<QuestionarioEvento> = transformerQuestionario(data, idEvento);

  const statoCivile: StatoCivile = transformerStatoCivile(
    data,
    idValore,
    idEvento,
    dateFormationAct,
    nascituro,
    valuesText,
    dataDead,
    dataMatrimonioAtti,
    dataLawCitizenship,
    dataDatiRegistroEmergenza,
    isLastStepEmergency,
    valuesDatiSpecificiCittadinanza,
    dataCittadinanza
  );

  const evento: Evento = transformerEvento(
    data,
    idEvento,
    idValore,
    descrizioneValore,
    dateFormationAct,
    dichiaranti?.find((itemDichiarante) =>
      withInterpreteCheck(true, itemDichiarante.configuration || '')
    ) || undefined, // Soggetti con gestione dell'interprete
    nascituro,
    dataDead,
    dataCittadinanza,
    dataDatiGeneraliRiconoscimento,
    dataDatiGenerali || dataDatiGen || dataDatiRegistroEmergenza,
    dataEventoRiconoscimento,
    valuesText,
    dataComposizioneAtto,
    dataComposizioneAttoDue,
    testoDelegaUnioneCivile,
    testoDelegaMatrimonio,
    dataTranscriptionBorn || dataTranscriptionBornTP,
    dataSpecificCivilUnion,
    Boolean(subjects?.find((item) => item.configuration === ConfigurationType.BASE14))
      ? '8'
      : undefined,
    dataMatrimonioAtti,
    dataDatiSeparazioniUC,
    isLastStepEmergency,
    dataSepar
  );

  const subjectsFiltred = (subjects || []).filter((itemSubject) => {
    const isWithDeceduto = Boolean(
      subjects?.find((item) => item?.codeSubject === CodeSubject.DECEDUTO)
    );

    // nella sezione scelto 1 comparente
    const isWith1Comparente: boolean =
      dataDead?.numberAppearing === ID_NUMBERS_COMPARENTI.ID_COMPARENTE1;

    // nella sezione scelti 2 comparenti
    const isWith2Comparente: boolean =
      dataDead?.numberAppearing === ID_NUMBERS_COMPARENTI.ID_COMPARENTE2;

    const isWithInterprete = withInterprete(subjects?.concat(sections || []));

    const valuesMomentary = { ...(itemSubject || {}), ...clearSubjectMomentary(itemSubject) };

    if (
      (itemSubject?.presenza === typePresence.Facoltativo ||
        itemSubject?.presenza === typePresence.FacoltativoObbligatorio) &&
      isObjectEmpty(valuesMomentary as Record<string, unknown>)
    ) {
      // se falcolatativo e l'oggetto è vuoto non salvare
      return false;
    }

    if (isSaveSingle) {
      return true;
    }

    return subjectIsVisibility(
      itemSubject,
      isWithInterprete,
      isWith1Comparente,
      isWith2Comparente,
      isWithDeceduto,
      valuesDeceduto,
      dataTranscriptionBorn || dataTranscriptionBornTP,
      dataGenitoreTrasmetteCittadinanza,
      valuesDatiSpecificiCittadinanza,
      dataRicGenitoreItaliano,
      dataEventoRiconoscimento,
      nascituro?.configuration === ConfigurationType.BASESCATTO ? nascituro : undefined,
      dataSpecificCivilUnion || dataMatrimonioAtti,
      dataSepar || dataTranscriptionSeparation || dataDatiSeparazioniUC,
      subjectIntest1
    );
  });

  const subjectUniCivScio = subjectsFiltred?.filter(
    (item) =>
      item?.codeSubject === CodeSubject.UNICIV1_SCIO ||
      item?.codeSubject === CodeSubject.UNICIV2_SCIO
  );

  const subjectAvvUniCivScio = subjectsFiltred?.filter(
    (item) =>
      item?.codeSubject === CodeSubject.AVVOCUC1 || item?.codeSubject === CodeSubject.AVVOCUC2
  );

  const subjectIntAnn = subjectsFiltred?.find((item) => item?.codeSubject === CodeSubject.INT_ANN);

  const soggettoList: Array<SoggettoList> | undefined = transformerSoggettoList(
    subjectsFiltred,
    dataTranscriptionBorn || dataTranscriptionBornTP
  );

  const figlioList: Array<FiglioList> | undefined = transformerFiglioList(
    subjectsFiltred.filter((itemSubj) =>
      keyAllChildren.includes((itemSubj.codeSubject || '') as CodeSubject)
    )
  );

  const datiNascita: DatiNascita | undefined = transformerDatiNascita(data, idEvento, nascituro);

  const datiDichiarante: DatiDichiarante | undefined = transformerDatiDichiarante(
    idEvento,
    Boolean(
      dichiaranti?.find(
        (item) =>
          item.codeSubject === CodeSubject.UNICIV1 ||
          item.codeSubject === CodeSubject.UNICIV2 ||
          item.codeSubject === CodeSubject.SPOSA ||
          item.codeSubject === CodeSubject.SPOSO
      )
    )
      ? undefined
      : dichiaranti
      ? dichiaranti[0]
      : undefined,
    dataDead
  );

  let valuesToTransformerEnteDichiarante: Array<SectionVM> =
    sectionsFiltred?.filter((item) =>
      CodeSectionEnteDichiarante.includes(item.codeSection as CodeSection)
    ) || [];

  if (dataAutorizzazioneRiconoscimento) {
    valuesToTransformerEnteDichiarante.push(dataAutorizzazioneRiconoscimento);
  }

  if (dataPubblicoImpiego) {
    valuesToTransformerEnteDichiarante.push(dataPubblicoImpiego);
  }

  if (dataTranscriptionBorn?.nameInstituteAbandonedMinor) {
    valuesToTransformerEnteDichiarante.push(dataTranscriptionBorn);
  }

  if (dataImpedimento) {
    valuesToTransformerEnteDichiarante = valuesToTransformerEnteDichiarante.concat(dataImpedimento);
  }

  if (dataTranscriptionNegoz) {
    valuesToTransformerEnteDichiarante.push(dataTranscriptionNegoz);
  }

  if (dataDatiProvvedimento) {
    valuesToTransformerEnteDichiarante.push(dataDatiProvvedimento);
  }

  const enteDichiaranteList: Array<EnteDichiaranteList> | undefined = transformerEnteDichiarante(
    valuesToTransformerEnteDichiarante
  );

  const datiMorte: DatiMorte | undefined = transformerDatiMorte(idEvento, dataDead, subjectIntAnn);

  const datiEventoMorte: DatiEventoMorte | undefined = transformerDatiEventoMorte(
    idEvento,
    dataDead
  );

  const datiEventoCittadinanza: DatiEventoCittadinanza | undefined =
    transformerDatiEventoCittadinanza(
      idEvento,
      dataCittadinanza || dataRicGenitoreItaliano,
      dataPubblicoImpiego,
      subjectCittadinanza,
      dataTranscriptionCitizenship,
      subjectOfficianteCitt
    );

  const certificatoSanitario: CertificatoSanitario | undefined = transformerCertificatoSanitario(
    dataDatiGeneraliRiconoscimento
  );

  const datiEventoRiconoscimento: DatiEventoRiconoscimento | undefined =
    dataEventoRiconoscimento?.codeSection === CodeSection.DATI_GENERALI_CONS_RICO_SENT ||
    dataEventoRiconoscimento?.codeSection === CodeSection.DATI_GENERALI_PRES_DOC_EVENTO ||
    dataEventoRiconoscimento?.codeSection === CodeSection.DATI_GENERALI_CONS_RICO_EVENTO ||
    dataAutorizzazioneRiconoscimento?.configuration === ConfigurationType.BASERICAU
      ? undefined
      : transformerDatiEventoRiconoscimento(
          dataDatiGeneraliRiconoscimento,
          dataAutorizzazioneRiconoscimento,
          dataEventoRiconoscimento,
          dataMatrimonioAtti,
          dataAgreeSon,
          subjectsFiltred.find((item) => item.codeSubject === CodeSubject.FIGLIO)
        );

  const datiAssenso: DatiAssenso | undefined = transformerDatiAssenso(
    idEvento,
    dataEventoRiconoscimento?.codeSection === CodeSection.DATI_GENERALI_ASS_RICO_P ||
      dataEventoRiconoscimento?.codeSection === CodeSection.DATI_GENERALI_RICO_GEN
      ? dataEventoRiconoscimento
      : undefined
  );

  const trascrizioneNascita: TrascrizioneNascita | undefined = transformerTrascrizioneNascita(
    dataTranscriptionBorn || dataTranscriptionBornTP,
    dataTranscriptionBirth,
    dataDatiGenerali,
    idEvento
  );

  const trascrizioneMorte: TrascrizioneMorte | undefined = transformerTrascrizioneMorte(
    dataTranscriptionDead,
    dataUltimoLuogo,
    idEvento
  );

  const trascrizioneCittadinanza: TrascrizioneCittadinanza | undefined =
    transformerTrascrizioneCittadinanza(
      idEvento,
      dataTranscriptionCitizenship,
      dataGenitoreTrasmetteCittadinanza,
      dataRicGenitoreItaliano,
      dataEsiAccProvvSindaco,
      subjectIntest1,
      transcriptionCitizenship,
      dataCittadinanza,
      subjectCittadinanza
    );

  const ascendente: Ascendente | undefined = transformerAscendente(dataAscendente);

  const attoCollegatoList: Array<AttoCollegato> | undefined =
    transformerAttoCollegatoList(dataAttoCollegatoList);

  const consenso: Consenso | undefined = transformerConsenso(
    dataDatiGeneraliMancatoConsenso,
    dataEventoRiconoscimento?.codeSection === CodeSection.DATI_GENERALI_CONS_ASS_RICO ||
      dataEventoRiconoscimento?.codeSection === CodeSection.DATI_GENERALI_CONS_RICO ||
      dataEventoRiconoscimento?.codeSection === CodeSection.DATI_GENERALI_CONS_ASS_COGNRID_RICO ||
      dataEventoRiconoscimento?.codeSection === CodeSection.DATI_GENERALI_CONS_RICO_SENT ||
      dataEventoRiconoscimento?.codeSection === CodeSection.DATI_GENERALI_CONS_RICO_EVENTO
      ? dataEventoRiconoscimento
      : undefined,
    dataAttoConsensoAcoP,
    dataMatrimonioAtti
  );

  const luogo: Luogo | undefined = transformerLuogo(
    dataUltimoLuogo ||
      dataSpecificCivilUnion ||
      dataMatrimonioAtti ||
      dataSepar ||
      dataTranscriptionMarriage ||
      dataCivilUnion ||
      dataDatiRiconcilianzione ||
      dataMarriage ||
      dataDatiSeparazioniUC
  );

  const datiAnnotazioneList: Array<DatiAnnotazioneList> | undefined =
    transformerDatiAnnotazioneList(idEvento, dataAnnotations, dataRegimePatrimoniale);

  const unioneCivileAtti: UnioneCivileAtti | undefined = transformerUnioneCivileAtti(
    idEvento,
    dataSpecificCivilUnion,
    testoDelegaUnioneCivile,
    subjectsFiltred?.find(
      (item) =>
        item?.codeSubject === CodeSubject.OFFICIANTE_UNI_CIV ||
        item?.codeSubject === CodeSubject.OFFICIANTE_MATR
    ),
    subjectUniciv,
    subjectUniCivScio,
    subjectsFiltred?.find((item) => item?.codeSubject === CodeSubject.SEGRCOM_UNI_CIV),
    dataTranscriptionCivilUnion || dataCivilUnion
  );

  const certificatoUnioneCivileList: Array<CertificatoUnioneCivileList> | undefined =
    transformerCertificatoUnioneCivileList(dataCertCivilUnionList);

  const regimePatrimoniale: RegimePatrimoniale | undefined =
    transformerRegimePatrimoniale(dataRegimePatrimoniale);

  const impedimentoList: Array<Impedimento> | undefined = transformerImpedimento(dataImpedimento);

  const matrimonioAtti: MatrimonioAtti | undefined = transformerMatrimonioAtti(
    idEvento,
    dataMatrimonioAtti || dataTranscriptionMarriage || dataMarriage,
    dataPubblicazioneList?.find((item) => item.codeSection === CodeSection.PUBBLICAZIONE_1),
    testoDelegaMatrimonio,
    subjectsFiltred?.find((item) => item?.codeSubject === CodeSubject.OFFICIANTE_MATR),
    subjectsFiltred?.find((item) => item?.codeSubject === CodeSubject.SEGRCOM_MATR),
    subjectsFiltred?.find((item) => item?.codeSubject === CodeSubject.SPOSO),
    subjectsFiltred?.find((item) => item?.codeSubject === CodeSubject.SPOSA),
    subjectOfficianteTras
  );

  const scioglimentoUnioneCivileAtti: ScioglimentoUnioneCivileAtti | undefined =
    transformerScioglimentoUnioneCivileAtti(
      idEvento,
      dataScioglimentoUnioneCivileAtti,
      dataDatiSeparazioniUC,
      subjectUniCivScio,
      subjectAvvUniCivScio
    );

  const pubblicazioneList: Array<Pubblicazione> | undefined =
    transformerPubblicazioneList(dataPubblicazioneList);

  const trascrizioneUnioneCivile: TrascrizioneUnioneCivile | undefined =
    transformerTrascrizioneUnioneCivile(idEvento, dataTranscriptionCivilUnion);

  const separazione: Separazione | undefined = transformerSeparazione(
    idEvento,
    dataSepar,
    subjectsFiltred?.find((item) => item?.codeSubject === CodeSubject.AVVOC1),
    subjectsFiltred?.find((item) => item?.codeSubject === CodeSubject.AVVOC2),
    subjectsFiltred?.find((item) => item?.codeSubject === CodeSubject.AVVOC5),
    dataDatiRiconcilianzione
  );

  const trascrizioneMatrimonioAtti: TrascrizioneMatrimonioAtti | undefined =
    transformerTrascrizioneMatrimonioAtti(idEvento, dataTranscriptionMarriage);

  const negoziazioneAssistita: NegoziazioneAssistita | undefined = transformerNegoziazioneAssistita(
    idEvento,
    dataDatiGeneraliNegoz,
    dataTranscriptionNegoz,
    dataDatiProvvedimento,
    subjectsFiltred?.find((item) => item?.codeSubject === CodeSubject.AVVOC3),
    subjectsFiltred?.find((item) => item?.codeSubject === CodeSubject.AVVOC4),
    subjectsFiltred?.find((item) => item?.codeSubject === CodeSubject.AVVOC5)
  );

  const datiIntegrativiTrascrizione: DatiIntegrativiTrascrizione | undefined =
    transformerDatiIntegrativiTrascrizione(idEvento, dataSupplementary);

  const trascrizioneSeparazioneAtti: TrascrizioneSeparazioneAtti | undefined =
    transformerTrascrizioneSeparazioneAtti(
      idEvento,
      dataTranscriptionSeparation,
      dataSepar,
      valuesToTransformerEnteDichiarante.find(
        (item) => item.codeSection === CodeSection.DATI_ATTO_TRASCRIZIONE
      )
    );

  const riconciliazione: Riconciliazione | undefined = transformerRiconciliazione(
    idEvento,
    dataDatiRiconcilianzione
  );

  const richiedente: Richiedente | undefined = transformerRichiedente(
    idEvento,
    dataTranscriptionBornTP
  );

  const annotazioneModificativa: AnnotazioneModificativa | undefined =
    transformerAnnotazioneModificativa(idEvento, dataAnnModificativa);

  let riconoscimentoList: Array<RiconoscimentoList> | undefined = [];
  const currentCodeSectionRiconsocimentoList =
    sectionsFiltred?.filter((item) =>
      CodeSectionRiconsocimentoList.includes(item.codeSection as CodeSection)
    ) || [];

  currentCodeSectionRiconsocimentoList.forEach((item) => {
    if (item.riconoscimentoList?.length) {
      riconoscimentoList = (riconoscimentoList || []).concat(item.riconoscimentoList);
    }
  });

  // eliminare duplicati, utile per il salva generale che potrebbe contenere delle copie
  riconoscimentoList = riconoscimentoList.filter((item, index, self) => {
    return (
      item.key.idRiconoscimento !== undefined &&
      index === self.findIndex((t) => t.key.idRiconoscimento === item.key.idRiconoscimento)
    );
  });

  return {
    questionarioEvento,
    statoCivile,
    evento,
    soggettoList,
    figlioList,
    datiNascita,
    datiDichiarante,
    enteDichiaranteList,
    datiMorte,
    datiEventoMorte,
    datiEventoCittadinanza,
    certificatoSanitario,
    datiEventoRiconoscimento,
    trascrizioneNascita,
    trascrizioneMorte,
    trascrizioneCittadinanza,
    ascendente,
    attoCollegatoList,
    consenso,
    luogo,
    datiAssenso,
    datiAnnotazioneList,
    unioneCivileAtti,
    certificatoUnioneCivileList,
    regimePatrimoniale,
    impedimentoList,
    matrimonioAtti,
    scioglimentoUnioneCivileAtti,
    pubblicazioneList,
    trascrizioneUnioneCivile,
    separazione,
    trascrizioneMatrimonioAtti,
    negoziazioneAssistita,
    datiIntegrativiTrascrizione,
    trascrizioneSeparazioneAtti,
    riconciliazione,
    richiedente,
    annotazioneModificativa,
    riconoscimentoList: riconoscimentoList,
  };
};
